import { useEffect, useRef, useState } from 'react';

import Simulator from '../../threejs/simulator';

interface Props {}

const AircraftInlineClouds: React.FC<Props> = ({}) => {
  const CSSBlock = 'card-content-jetquity';

  return (
    <div className={CSSBlock}>
      <div className={`${CSSBlock}__background`} />
      <div className={`${CSSBlock} `}>
        <div className={`clouds`}>
          <div className={`clouds-1`} />
          <div className={`clouds-2`} />
          <div className={`clouds-3`} />
          <div className={`clouds-hue`} />
        </div>
      </div>
    </div>
  );
  // return <canvas ref={canvasRef} width={400} height={400} />;
};

export default AircraftInlineClouds;
